import React, { FC, useEffect } from 'react';
import { ToggleButton } from 'components/Buttons/ToggleButton/ToggleButton';
import { usePlayer } from 'providers/player/PlayerContext';
import { useAuth } from 'providers/useAuth/AuthContext';
import { useNavigate } from 'react-router';
import { StaticPageRoutes } from 'types/RouteTypes';
import { OptionNameSub, PageWrapper, Section } from 'components/Pages/Settings/PageSettingsCommon.css';
import translate from 'utils/fnTranslate';
import { useApp } from 'providers/useApp/AppContext';
import { HelmetWrapper } from 'components/HelmetWrapper/HelmetWrapper';
import { getHelmetData } from 'utils/fnHelmet';
import OptionFocusable from 'components/Pages/Settings/OptionFocusable';
import { PageHeading } from 'components/PageHeading/PageHeading.css';

const PageAccessibility: FC = () => {
    const { setPageTitle } = useApp();
    const { accessibilitySound, accessibilitySubs, setAccessibilitySound, setAccessibilitySubs } = usePlayer();
    const { isGuest } = useAuth();
    const navigate = useNavigate();

    const clickListener = (link) => {
        navigate(link);
    };

    useEffect(() => {
        setPageTitle(translate('SETTINGS_ACCESSIBILITY'));
    }, []);

    return (
        <HelmetWrapper {...getHelmetData(translate('SETTINGS_ACCESSIBILITY'))}>
            <PageWrapper>
                <PageHeading srOnly>{translate('SETTINGS_ACCESSIBILITY')}</PageHeading>
                {!isGuest && (
                    <Section>
                        <OptionFocusable
                            title={translate('SETTINGS_ACCESSIBILITY_AUDIO')}
                            actionComponent={<ToggleButton checked={accessibilitySound} ignoreClick />}
                            aria-checked={accessibilitySound}
                            onClick={() => setAccessibilitySound((prev) => !prev)}
                            role="switch"
                        />
                        <OptionNameSub style={{ marginBottom: 20 }}>{translate('SETTINGS_ACCESSIBILITY_AUDIO_HINT')}</OptionNameSub>

                        <OptionFocusable
                            title={translate('SETTINGS_ACCESSIBILITY_SUBTITLES')}
                            actionComponent={<ToggleButton checked={accessibilitySubs} ignoreClick />}
                            aria-checked={accessibilitySubs}
                            onClick={() => setAccessibilitySubs((prev) => !prev)}
                            role="switch"
                        />
                        <OptionNameSub style={{ marginBottom: 20 }}>{translate('SETTINGS_ACCESSIBILITY_SUBTITLES_HINT')}</OptionNameSub>

                        <OptionFocusable
                            title={translate('SETTINGS_SUBTITLE_APPEARANCE')}
                            onClick={() => clickListener(StaticPageRoutes.ACCESSIBILITY_SUBTITLES)}
                        />
                    </Section>
                )}
            </PageWrapper>
        </HelmetWrapper>
    );
};

export default PageAccessibility;
